import { BakerLoanSolutionsLogo } from '@bakerweb/components';
import { Box, Container, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/GridLegacy';
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const { pathname } = useLocation();

  const isHome = pathname === '/';

  const simpleFooter = (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: 'center',
        position: 'relative',
        bgcolor: 'background.default'
      }}
    >
      <Container>
        <BakerLoanSolutionsLogo sx={{ width: 200, mb: 1, mx: 'auto' }} />

        <Typography variant="caption" component="div">
          © The Baker Group. All rights reserved
        </Typography>
      </Container>
    </Box>
  );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: 'background.default'
      }}
    >
      <Divider />

      <Container sx={{ pt: 5 }}>
        <Grid
          container
          justifyContent={{
            xs: 'center'
          }}
          sx={{
            textAlign: {
              xs: 'center'
            }
          }}
        >
          <Grid item sx={{ mb: 10 }}>
            <BakerLoanSolutionsLogo sx={{ width: 200 }} />
            <Typography variant="caption" component="div" sx={{ mt: -5 }}>
              © 2024. All rights reserved
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );

  return isHome ? simpleFooter : mainFooter;
}
